import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getReportsFinanceByWorkTypes(companyId, query) {
	return dataTransferWrap(
		ModulesMap.REPORTS_FINANCE_BY_WORK_TYPE,dtConfig[ModulesMap.REPORTS_FINANCE_BY_WORK_TYPE].getReportsFinanceByWorkTypes,
		{
			urlParams: {
				companyId: companyId,
			},
			params: query,
		},
	)
}

export default {
	getReportsFinanceByWorkTypes,
}
